module.exports = __webpack_public_path__ + "static/media/emptying.1bc9997c.mp4";